import React from 'react';
import PropTypes from 'prop-types';
import CustomDialog from '@/components/common/CustomDialog';
import Loader from '@/components/common/Loader';
import ConstituentType from '@/constants/ConstituentType';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import translate from '@/lib/intl/translate';
import { isPersonConstituentType } from '@/utils/constituentUtils';

function EditConstituentTypeModal({ constituentId, onClose, open }) {
  const { data, isBusy, convertConstituentType } =
    useConstituent(constituentId);
  const dialogProps = {
    dialogHeader: translate('CONSTITUENT_CONVERTING'),
    onClose,
    open,
  };
  let isPerson = false;
  if (data) {
    isPerson = isPersonConstituentType(data);
    dialogProps.actionButtonLabel = translate('CONSTITUENT_CONVERT');
    dialogProps.disableActionButton = isBusy;
    dialogProps.handleActionButton = async () => {
      if (!data) return;
      await convertConstituentType(
        isPerson ? ConstituentType.ORG : ConstituentType.PERSON,
      );
      onClose();
    };
  } else {
    dialogProps.children = <Loader isCentered className="w-full" />;
    dialogProps.showDialogActions = false;
  }
  return (
    <CustomDialog {...dialogProps}>
      {data ? (
        <div className="type-body1">
          <p className="mb-4">
            {translate('CONSTITUENT_CONVERT_MESSAGE', {
              from: translate(
                isPerson
                  ? 'CONSTITUENTS_NEW_CONSTITUENT_INDIVIDUAL_LABEL'
                  : 'CONSTITUENTS_NEW_CONSTITUENT_ORG_LABEL',
              ),
              to: translate(
                isPerson
                  ? 'CONSTITUENTS_NEW_CONSTITUENT_ORG_LABEL'
                  : 'CONSTITUENTS_NEW_CONSTITUENT_INDIVIDUAL_LABEL',
              ),
            })}
          </p>
          {/* TODO(jon): Designs indicate we should show which fields will be 
          affected by conversion in this space, but those designs may be
          subject change so not adding that for now.
          https://www.figma.com/file/HeO9I4TAdy7T0ex0Ha8co0/Editing-Constituent-Types?node-id=536%3A16173 */}
          <p>{translate('CONSTITUENT_CONVERT_CONFIRM')}</p>
        </div>
      ) : (
        <Loader isCentered className="w-full" />
      )}
    </CustomDialog>
  );
}

EditConstituentTypeModal.propTypes = {
  constituentId: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

EditConstituentTypeModal.defaultProps = {
  constituentId: null,
  onClose: () => {},
  open: false,
};

export default EditConstituentTypeModal;
